import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {LeadState} from '@/store/types'

type LeadGetter = GetterTree<LeadState, any>
type LeadMutation = MutationTree<LeadState>
type LeadAction = ActionTree<LeadState, any>

const state: LeadState = {
  lead: null,
}


const getters: LeadGetter = {
  lead: (state) => state.lead,
}

const mutations: LeadMutation = {
  setLead: (state, payload) => {
    state.lead = Object.assign({}, payload)
  },
}

const actions: LeadAction = {

}

export default {
  state,
  getters,
  mutations,
  actions,
}
